import { AxiosInstance } from "axios";
import { IResponseBody } from "../../Schemas/EndPoint";
import { PbxServerSchema } from "../../Schemas/PbxServer";

export interface PbxServerResponseBody extends IResponseBody {
  data: {
    pbx_server: PbxServerSchema;
  };
}

export interface PbxServerCreateRequestBody {
  workspace_id: null | string;
  pbx_driver: string;
  server_url: string;
  username: string;
  password: string;
  max_pending_calls:number;
  status:string ;
  caption:string;
  description:string
}

export class PbxServerCreateRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath() {
    return `/admin/pbx-servers/create`;
  }

  async send(
    contactCreateBody: PbxServerCreateRequestBody
  ): Promise<PbxServerResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath(),
        contactCreateBody
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
